import { InternshipAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainInternshipsSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type Args = {
  lang: UserLocale;
  q?: string;
  radius?: 'state' | 'country' | 'auto' | string | null;
  filters?: InternshipAlgoliaApiQueryFilters;
};

export function getMainInternshipsSearchRoutePath({
  lang,
  filters,
  q,
  radius,
}: Args) {
  // Extract the segment based on type
  const segment = HOME_PAGE_SLUGS.INTERNSHIP[lang];

  const queryParams: Record<string, unknown> = {};
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;

  if (filters) {
    // Merge basic and filter-derived query parameters
    Object.assign(queryParams, transformSearchFiltersToQueryParams(filters));
  }

  return mainInternshipsSearchRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
